import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_snack_bar = _resolveComponent("snack-bar")!
  const _component_navigation_drawer = _resolveComponent("navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_live_watch_hud = _resolveComponent("live-watch-hud")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "main-background" }, {
    default: _withCtx(() => [
      _createVNode(_component_snack_bar, {
        message: _ctx.snackbarMessage,
        show: _ctx.snackbarShow,
        level: _ctx.snackbarLevel
      }, null, 8, ["message", "show", "level"]),
      (_ctx.authenticated)
        ? (_openBlock(), _createBlock(_component_navigation_drawer, {
            key: 0,
            user: _ctx.user
          }, null, 8, ["user"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.authenticated)
        ? (_openBlock(), _createBlock(_component_live_watch_hud, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}